import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import {ROLE_SUPER_ADMIN} from 'shared/constant/lookup/role'

const usePutStoreManagerPassword = (onSuccess) => {
	const {idx} = useParams()
	const [userRole] = useRoleCookie()

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const request = (newPassword) => {
		const url =
			userRole === ROLE_SUPER_ADMIN
				? `/admin/franchise/manager/${idx}`
				: `/admin/store/my/manager/${idx}`

		fetchRequest('PUT', url, {
			password: newPassword, // Note: the curl example uses "password" not "new_password"
		})
	}

	useEffect(() => {
		if (!fetchResult) return

		switch (fetchResult?.statusCode) {
			case 200:
				setAlert('비밀번호가 성공적으로 변경되었습니다.')
				if (onSuccess) {
					onSuccess()
				}
				break
			case 400:
				setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				setAlert('매니저 데이터가 존재하지 않습니다.')
				break
			default:
				break
		}
	}, [fetchResult])

	return [request, isLoading]
}

export default usePutStoreManagerPassword
